<template>
  <div>
    <router-view />
    <snackbar />

    <modal-delete />
  </div>

</template>

<script>
import Snackbar from '@/components/snackbar/snackbar.vue';
import ModalDelete from '@/components/core/DialogDelete.vue';

export default {
  name: 'App',

  components: {
    Snackbar,
    ModalDelete,
  },
};
</script>
